export const languages: ('it' | 'en' | 'es' | 'fr' | 'de')[] = ['it', 'en', 'es', 'fr', 'de'];
